import { startDeviceInfoSubscriptions } from "../feat/appState/deviceInfo";
import { startChatpoolSubscriptions } from "../feat/chatpool/chatpool.slice";
import { startProfileSubscriptions } from "../feat/profile/profile.slice";
import { startItineraryMapSubscriptions } from "./itineraryState/itineraryMap.slice";
import { startOrgConfigSubscriptions } from "./orgConfig.slice";

let started = false;

/**
 * Starts the store's cross-slice subscriptions. The slices import `useBoundStore` and the bound
 * store imports the slices, so a slice cannot subscribe while it is being evaluated. Each used to
 * defer with a module-scope `setTimeout(…, 100)`, which raced the module loader whenever modules
 * load asynchronously (the test runner always does) and read `useBoundStore` before it existed.
 *
 * The app entry calls this once, 100ms after every module has loaded (the delay the slices used to
 * keep, so start-up timing is unchanged). Tests that need a subscription
 * call the slice's own `start…Subscriptions` (or this) explicitly. Safe to call again.
 */
export function startStoreSubscriptions() {
  if (started) return;
  started = true;
  startDeviceInfoSubscriptions();
  startChatpoolSubscriptions();
  startProfileSubscriptions();
  startItineraryMapSubscriptions();
  void startOrgConfigSubscriptions();
}
